import React from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import { Link } from "components/common/router";
import Routes from "routing/Routes";
const EventDefinitionLink = ({ title, id }) => {
  const { permissions } = useCurrentUser();
  if (!title) {
    return /* @__PURE__ */ React.createElement("em", null, id);
  }
  if (isPermitted(permissions, `eventdefinitions:read:${id}`)) {
    return /* @__PURE__ */ React.createElement(Link, { to: Routes.ALERTS.DEFINITIONS.show(id) }, title);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
};
export default EventDefinitionLink;
